import { observable, action, runInAction } from 'mobx';
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';
import webEDIShipToAPI from '../apis/webEDIShipToAPI'
import alertMessage from '../utils/alertMessage'

export default class WebEDIShipToStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;

  /*SearchResult start*/
  @observable searchItem = {
    "shipTo": ''
  }
  @observable shipToList = []
  @action
  async onSearchShipToAction(params,pageNo,pageSize) {
    this.isFetching = true;
    this.shipToList = [];
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.itemCount = 0
    try {
      const response = await webEDIShipToAPI.searchAction(params,pageNo,pageSize);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.shipToList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params;
        }
      })
    } catch (err) {
      alertMessage.error(err.message);
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*SearchResult end*/
  @action
  onChangeShipToList(value){
    this.shipToList=value
  }
  /*add*/
  @action
  async onAddShipTonAction(params){
    this.isFetching = true
    try {
      const response = await webEDIShipToAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Add Success！')
          this.onSearchShipToAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Add Failed！' + response.data.messageEn +'')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*edit*/
  @action
  async onEditShipToAction(params){
    this.isFetching = true
    try {
      const response = await webEDIShipToAPI.editAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Edit Success！')
          this.onSearchShipToAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Edit Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*delete*/
  @action
  async onDeleteShipToAction(params) {
    this.isFetching = true
    try {
      const response = await webEDIShipToAPI.editAction(params);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Delete Success！')
          this.onSearchShipToAction(this.searchItem,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Delete Failed！' + response.data.messageEn +'')
        }
      });
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNo = pageNo;
      this.pageSize = pageSize;
    });
    this.onSearchShipToAction(this.searchItem,this.pageNo,this.pageSize)
  }
  @action
  onChangePageNo(){
    this.itemCount = 0;
    this.pageNo = 1;
    this.pageSize = PAGE_SIZE_DEFAULT;
  }
}
